<template>
    <div class="list-div">
        <div class="form base-form-div">
            <el-form size="mini" :rules="rules" :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
                <el-form-item label="书签名称:" prop="name">
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
            </el-form>
            <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">添加</el-button>
        </div>
        <div class="list">
            <div v-for="(item, index) in list" class="item">
                <el-image @click="flyToView(item)" :src="item.data"></el-image>
                <div class="operate">
                    <div>
                        <span>{{ item.name }}</span>
                    </div>
                    <div>
                        <svg-icon @click="deleteView(index)" class="icon" icon-class="p-clear" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { dataURLtoBlob } from './utils.js'
export default {
    data() {
        return {
            ruleForm: {
                name: ""
            },
            rules: {
                name: [
                    { required: true, message: "请输入书签名称", trigger: "blur" },
                ],
            },
            src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
            list: []
        };
    },

    mounted() {
        var list_str = localStorage.getItem("Bookmark-data");
        if (list_str) {
            this.list = JSON.parse(list_str);
        }
    },

    beforeDestroy() {
        localStorage.setItem("Bookmark-data", JSON.stringify(this.list));
    },
    methods: {
        getUrl(blob) {
            return URL.createObjectURL(blob);
        },
        deleteView(index) {
            this.list.splice(index, 1);
        },
        flyToView(item) {
            var view = item.view;
            DBmap.setCameraView(view);
        },
        isRepeat() {
            var name = this.ruleForm.name;
            var has = this.list.filter(v => {
                return v.name == name;
            });

            return has.length > 0 ? true : false;
        },
        submitForm(formName) {
            var has = this.isRepeat();
            if (has) {
                this.$message({
                    message: "该标签名称已经存在，请重新命名！",
                    type: "error",
                });
                return;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    var url = DBmap.expImage();
                    var view = DBmap.getCameraView();
                    var item = new Object();
                    item.data = url;//dataURLtoBlob(url);
                    item.name = this.ruleForm.name;
                    item.view = view;
                    this.list.push(item);

                    console.log(item)

                    this.$message({
                        message: "添加成功",
                        type: "success",
                    });
                    this.ruleForm.name = "";
                } else {
                    return false;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.list-div {
    height: 100%;
}

.form {
    margin-bottom: 20px;
    padding: 0 0 0 0;
}

.list {
    overflow-y: auto;
    height: 600px;

    .item {
        position: relative;
        cursor: pointer;

        .operate {
            position: absolute;
            left: 0;
            bottom: 10px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 0 10px;
            box-sizing: border-box;
            background-color: rgba(#000, 0.3);

            .icon {
                width: 20px;
                height: 20px;
            }
        }
    }
}
</style>

<style lang="scss">
.list-div {
    .el-input {
        width: auto;
    }

    .el-image {
        height: 130px;
        width:100%;
    }
}
</style>